module.exports = __webpack_public_path__ + "img/containerFrontLeftOutline.5721f1bc.svg";